import React from 'react'

const ObscurityPattern = () => {
  return (
    <div
      className={`absolute top-0 left-0 w-full h-full z-5`}
    >
      <div
        className="absolute top-0 left-0 w-full h-full opacity-80"
        style={{
          background:
            'repeating-linear-gradient(45deg, transparent, transparent 3px, rgba(0,0,0,0.3) 2px, rgba(0,0,0,0.3) 8px)',
        }}
      ></div>
    </div>
  )
}

export default ObscurityPattern
